import styled, { css } from 'styled-components'
import { NavLink } from 'react-router-dom'
import dashboardIcon from '../../../assets/icons/dashboard.svg'
import recommendationsIcon from '../../../assets/icons/recommendations.svg'
import priorityBoardIcon from '../../../assets/icons/priorities-board.svg'
import supportCasesIcon from '../../../assets/icons/support-cases.svg'
import reportsIcon from '../../../assets/icons/reports.svg'
import documentIcon from '../../../assets/icons/documents.svg'

const Col = styled.div`
  display: flex;
  flex-direction: column;
  ${p => (p.collapsed && 'align-items: center')};

  a {
    padding: ${p => (p.collapsed ? '10px 14px' : '10px 27px')};
    display: flex;
    align-items: center;
    position: relative;
    transition: background 0.3s ease;

    span {
      ${p => p.collapsed && 'opacity: 0; width: 0; overflow: hidden;'};
      font-size: 14px;
      font-weight: 500;
      position: absolute;
      top: 50%;
      left: 69px;
      transform: translateY(-50%);
      color: var(--color-text-primary);
      white-space: nowrap;
      transition: opacity 0.3s ease 0.2s, width 0.3s ease;
    }

    span,
    img {
      opacity: 0.7;
      transition: opacity 0.2s ease;
    }

    &:hover {
      background: var(--color-sidebar-hover);
      ${p => p.collapsed && 'background: var(--color-sidebar-hover)'};

      span,
      img {
        opacity: 1;
      }

      span {
        ${p =>
          p.collapsed &&
          css`
            display: flex;
            align-items: center;
            padding: 20px 7px;
            left: 60px;
            height: 100%;
            background: var(--color-bg-sidebar);
            white-space: nowrap;
            z-index: 9;
            width: 200px;
            border-radius: 0 8px 8px 0;
            box-shadow: 2px 0 8px rgba(0, 0, 0, 0.2);
          `}
      }
    }

    &.active {
      background: var(--color-primary);

      span,
      img {
        opacity: 1;
      }

      span {
        font-weight: 900;
        ${p => p.collapsed ? 'color: var(--color-text-primary)' : 'color: var(--color-bg-main)'};
      }

      img {
        filter: brightness(0);
      }
    }

    &:focus {
      outline: 2px solid var(--color-focus);
      outline-offset: -2px;
    }
  }
`

const Nav = ({ collapsed }) => {
  return (
    <Col collapsed={collapsed}>
      <NavLink to='/' exact>
        <img src={dashboardIcon} alt='dashboard-icon' />
        <span>Dashboard</span>
      </NavLink>
      <NavLink to='/recommendations'>
        <img src={recommendationsIcon} alt='recommendations-icon' />
        <span>Recommendations</span>
      </NavLink>
      <NavLink to='/priority-board'>
        <img src={priorityBoardIcon} alt='priority-board-icon' />
        <span>Team Support Board</span>
      </NavLink>
      <NavLink to='/support-cases'>
        <img src={supportCasesIcon} alt='support-cases-icon' />
        <span>Support Cases</span>
      </NavLink>
      <NavLink to='/reports'>
        <img src={reportsIcon} alt='reports-icon' />
        <span>Reports</span>
      </NavLink>
      <NavLink to='/documents'>
        <img src={documentIcon} alt='documents-icon' />
        <span>Documents</span>
      </NavLink>
    </Col>
  )
}

export default Nav
